var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_517_82)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_517_82",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_517_82",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_517_82",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABYlAAAWJQFJUiTwAAADOklEQVRIia1WTWgkRRT+qrp6ujuzHWczSTomuxuzBjNmomwOsnoaEfQU2FwjKHpyYU8rCx706k0QPHgTAt6EPQgBWYRAg4gnb8IKmpWNuplkJkqmq1PVXT8ewmQzPRMza3zQNP1Vve97r6reqybr1+8hDEIMYQ0h5Dwj7G/mOS0A8VkOuVRgwzADwG6yu/Zr8tN7njOC2oUXbw4SGAmCPr9hBRot+WhVaAGpJRLdWR5llZ4JJeYOdKSDQJ2Znu+/+P7rXCcRAQEhFC25swrgrWEiGyhQsEYra66misMhDigI2rIZCZMuuJTBpQwOOZ3m1BEhZPdd66iDurWPs9JWo53tvgHgxnkzaOxlj1ZS1QE5EeXRMjVfSjWvCSP+laC7yY0CHgKIksNkfE82V5RRcIhzIiqCQ8XRkjurk/5MCqAFoA1AFnhisn793gfb6dbtjjqIjFVQRp2R1OlGCAGjLhhxUS1N/HApmPuM7Yjf39mTzYiC/GfirllrkesMOTI8VMnLFbca02ppcsN3Amirzy3QNQOLCS9qBU75Ph0rVzcWR699FJYq/4uIgcV0cPn+cxeWbgFYpwDiMAi/q4fL71a9yfQ8IgYWz5TnN58Na+8D+Ap4fExjAOuLo9fenAouPTSwT0xOCMFC+MKXl8O5jwF808WLdfB1bWzp7engyo/diIYxhzpYHF3+dCp8+gsAmyfHBhVa7Dt+k5DhTpWBhUNcuLTUxIAOy7qNzaVH3VBnBlwl9dzkYOTsZtstutxk4/u83Tc+iOFGbrJoqPBPWKp4LfKn+wNINUfhWZJGeOQJCy/RB3UAa0WcdfKDIlbPjexpbsDRRs4EszFXvNaWzZ4MCaHgOpnLbDbeJ8B1p4gtZCbvAape9OfV8sKHvu89AIB93l7Z4j/f4SoBBQEFQZp3MGhpWW6KDRBXjNWgxIHPRjBffv6Ti+WxDSHk8QkZK1dR8V6Jt/mD238c/vZabhSM1VAmv9gnUHH7svpWGLFWLU1szvizn5/yBxEDwOxTVzvj3tTd7XTrjtRiOmDlX4pk5O6r3xex47tBSR0z7+geEELC973jSUZZUEbARYrtdAtSC8yHi0Uu/AOj716KTWqZ2gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.23470b84a777bb990d6600475bb73f33.svg";
export { ForwardRef as ReactComponent };